<template>
  <div class="home">
    <!-- <Banner :banner="banner"/> -->
    <div class="section-box">
      <div class="section-item item-0">
        <div class="main-box">
          <div class="title">老酒网电商运营 一站式营销专家</div>
          <div class="content">深耕酒水领域 全链路托管服务</div>
        </div>
      </div>
      <div class="section-item item-1">
        <div class="main-box">
          <div class="section-header">
            <img :src="itemImgArr[0]" alt="">
          </div>
          <div class="section-info mt-20">
            <div class="info-left">
              <img :src="aboutBanner" alt="">
            </div>
            <div class="info-right">
              <div class="info-context">
                四川老酒网科技有限公司(原 成都柒泉乾阳网络科技有限公司)成立于2012年，是较早一批从事天猫和京东白酒类目厂家直营销售的电商企业，公司经过八年的发展和锤炼，始终秉持以互联网为背景，以大数据为依托，以效果运营为导向，逐步发展成为了一家致力于提供酒水线上销售全产业链运营服务的互联网高效整合运营公司。
              </div>
              <CommonBtn :span="'了解更多'" @goChildPage="goChildPage"/>
            </div>
          </div>
        </div>
      </div>
      <div class="section-item item-2">
        <div class="main-box">
          <div class="section-header">
            <img :src="itemImgArr[1]" alt="">
          </div>
          <div class="section-info">
            <dl class="item" v-for="(item, index) in advantageArr" :key="index">
              <dt>{{item.title}}</dt>
              <dd>{{item.content}}</dd>
            </dl>
          </div>
        </div>
      </div>
      <div id="item-3" class="section-item item-3">
        <vueCanvasNest :config="config" :el="'#item-3'"> </vueCanvasNest>
        <div class="main-box">
          <div class="section-header">
            <img :src="itemImgArr[2]" alt="">
          </div>
          <div class="section-info">
            <div class="item" v-for="(item, index) in businessArr" :key="index">
              <div :class="['img','img'+index]"></div>
              <div class="txt">{{item}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-item item-4">
        <div class="main-box">
          <div class="section-header">
            <img :src="itemImgArr[3]" alt="">
          </div>
          <div class="section-info">
            <div :class="['item','item'+index]" v-for="(item, index) in brandImgArr" :key="index">
              <img :src="item" alt="">
            </div>
          </div>
          <MoreIndex :span="'更多案例展示'" @goPage="goPage"/>
        </div>
      </div>
    </div>
    <!-- <vueCanvasNest :config="config" :el="'#info'"> </vueCanvasNest> -->
  </div>
</template>

<script>
import vueCanvasNest from 'vue-canvas-nest';
import MoreIndex from '@/components/common/more'
import Banner from '@/components/common/banner';
import CommonBtn from '@/components/common/btn'
export default {
  name: 'Home',
  components: { vueCanvasNest,Banner,CommonBtn, MoreIndex },
  data () {
    return {
      config:{
        // color: '0,0,255',
        opacity: 0.7,
        zIndex: 1,
        count: 199,
      },
      aboutBanner:require('../assets/images/home/about_banner.png'),
      itemImgArr:[
        require('../assets/images/home/title1.png'),
        require('../assets/images/home/title2.png'),
        require('../assets/images/home/title3.png'),
        require('../assets/images/home/title4.png'),
      ],
      advantageArr:[
        {
          title:'全托管服务',
          content:'老酒网提供对品牌电商的一站式解决方案和安全高效的托管服务。'
        },
        {
          title:'专业的电商团队',
          content:'老酒网项目人员多为经验丰富的电商资深运营，总经理从业电商近20年，公司10年经验以上运营8名。'
        },
        {
          title:'全链路全渠道',
          content:'线上与线下的密切结合，老酒网作为全渠道解决方案的开拓者，致力于协助品牌实施渠道拓展策略。'
        },
        {
          title:'技术与创新',
          content:'老酒网更加注重对各线上线下的销售系统、数据采集和分析、人工智能等技术的开拓与探索。'
        }
      ],
      businessArr:['店铺运营','内容直播','视觉设计','客服服务','数字营销','分销管理','物流仓储'],
      brandImgArr:[
        require('../assets/images/home/logo1.png'),
        require('../assets/images/home/logo2.png'),
        require('../assets/images/home/logo3.png'),
        require('../assets/images/home/logo4.png'),
        require('../assets/images/home/logo5.png'),
        require('../assets/images/home/logo6.png'),
        require('../assets/images/home/logo7.png'),
      ],
    }
  },
  methods: {
    goChildPage() {
      this.$router.push({
        name:'CompanyIntroduction'
      })
    },
    goPage() {
      this.$router.push({
        name:'CooperationBrand'
      })
    }
  },
  
}
</script>

<style lang="scss" scoped>
  .home{
    width: 100%;
    .section-box{
      width: 100%;
      .main-box{
        .section-header{
          text-align: center;
        }
      }
      .section-item{
        overflow: hidden;
        width: 100%;
        &.item-0{
          height: 885px;
          background: url(../assets/images/home/banner.jpg) no-repeat 100% 100%;
          text-align: center;
          color: #fff;
          .title{
            font-size: 50px;
            font-weight: bold;
            margin-top: 300px;
          }
          .content{
            width: 650px;
            height: 90px;
            line-height: 90px;
            margin: 0 auto;
            font-size: 40px;
            border: 1px solid #fff;
            box-sizing: border-box;
          }
        }
        &.item-1{
          height: 752px;
          background: url(../assets/images/home/bg1.png) no-repeat 100% 100%;
          .section-info{
            display: flex;
            .info-right{
              position: relative;
              font-size: 22px;
              text-align: left;
              margin: 25px 0 0 42px;
              letter-spacing: 2px;
              .info-context{
                line-height: 200%;
                margin-bottom: 20px;
              }
            }
          }
        }
        &.item-2{
          height: 728px;
          background: url(../assets/images/home/bg2.png) no-repeat 100% 100%;
          .section-info{
            display: flex;
            justify-content: space-around;
            margin-top: 50px;
            .item{
              width: 260px;
              height: 390px;
              border: 1px solid #fefffb;
              text-align: center;
              padding: 84px 30px 0 30px;
              box-sizing: border-box;
              dt{
                color: #fefefe;
                font-size: 22px;
              }
              dd{
                color: #a8a8a8;
                font-size: 16px;
                margin-top: 70px;
                text-align: left;
              }
            }
          }
        }
        &.item-3{
          height: 900px;
          position: relative;
          .section-info{
            height: auto;
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
            .item{
              width: 120px;
              height: 130px;
              margin: 100px 80px;
              display: flex;
              flex-direction: column;
              align-items: center;
              cursor: pointer;
              .img{
                width: 120px;
                height: 120px;
                background-image: url(../assets/images/home/icon_back.png);
                &.img0{
                  background-position:  0px 0px;
                  &:hover{
                    background-position:  0px -140px;
                  }
                }
                &.img1{
                  background-position:  -140px 0px;
                  &:hover{
                    background-position:  -140px -140px;
                  }
                }
                &.img2{
                  background-position:  -280px 0px;
                  &:hover{
                    background-position:  -280px -140px;
                  }
                }
                &.img3{
                  background-position:  -420px 0px;
                  &:hover{
                    background-position:  -420px -140px;
                  }
                }
                &.img4{
                  background-position:  -560px 0px;
                  &:hover{
                    background-position:  -560px -140px;
                  }
                }
                &.img5{
                  background-position:  -700px 0px;
                  &:hover{
                    background-position:  -700px -140px;
                  }
                }
                &.img6{
                  background-position:  -840px 0px;
                  &:hover{
                    background-position:  -840px -140px;
                  }
                }
              }
              .txt{

              }
            }
          }
        }
        &.item-4{
          height: 900px;
          background: url(../assets/images/home/bg3.png) no-repeat 100% 100%;
          .more{
            margin-top: 96px;
          }
          .section-info{
            height: auto;
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
            .item{
              height: 225px;
              line-height: 225px;
              text-align: center;
              background-color: #fff;
              margin-top: 50px;
              border-radius: 10px;
              img{
                vertical-align: middle;
              }
              &.item0{
                width: 445px;
              }
              &.item1{
                width: 330px;
              }
              &.item2{
                width: 383px;
              }
              &.item3{
                width: 220px;
              }
              &.item4{
                width: 330px;
              }
              &.item5{
                width: 360px;
              }
              &.item6{
                width: 230px;
              }
            }
          }
        }
      }
    }
  }  
</style>
